export const COOKIE_POLICY_LINK = "https://www.idwalmarine.com/terms/cookie-policy";
export const DATA_PRIVACY_EMAIL = "Privacy@Idwalmarine.com";
